import i18nData from '../i18nData'
var cb = {
  lang: {
    template: (resid) => {
      var locale = window.localStorage.getItem('locale') || 'zhcn'
      var word = i18nData[locale][resid] || ""
      if (!word) {
        console.error("resid:" + resid + "WordNotFound")
      }
      return word
    }
  }
}
export default cb


// WEBPACK FOOTER //
// ./src/cblang.js